"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class MarketApi extends runtime.BaseAPI {
    /**
     * Get daily history for security
     */
    getHistoryRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
                throw new runtime.RequiredError('symbol', 'Required parameter requestParameters.symbol was null or undefined when calling getHistory.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/markets/stocks/history/{symbol}`.replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.HistoricalPriceFromJSON));
        });
    }
    /**
     * Get daily history for security
     */
    getHistory(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getHistoryRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get intraday history for security
     */
    getIntradayHistoryRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
                throw new runtime.RequiredError('symbol', 'Required parameter requestParameters.symbol was null or undefined when calling getIntradayHistory.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/markets/stocks/intraday/{symbol}`.replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.HistoricalPriceFromJSON));
        });
    }
    /**
     * Get intraday history for security
     */
    getIntradayHistory(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getIntradayHistoryRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    getMarketStatusRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/markets`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.MarketFromJSON(jsonValue));
        });
    }
    /**
     */
    getMarketStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMarketStatusRaw();
            return yield response.value();
        });
    }
    /**
     * Get option chains for underlying symbol
     */
    getOptionChainsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
                throw new runtime.RequiredError('symbol', 'Required parameter requestParameters.symbol was null or undefined when calling getOptionChains.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/markets/stocks/options/chains/{symbol}`.replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.OptionChainFromJSON));
        });
    }
    /**
     * Get option chains for underlying symbol
     */
    getOptionChains(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOptionChainsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get a stock option contract quote
     */
    getOptionContractRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
                throw new runtime.RequiredError('symbol', 'Required parameter requestParameters.symbol was null or undefined when calling getOptionContract.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/markets/stocks/options/contracts/{symbol}`.replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.OptionContractFromJSON(jsonValue));
        });
    }
    /**
     * Get a stock option contract quote
     */
    getOptionContract(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOptionContractRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get option expiration dates for underlying symbol
     */
    getOptionExpirationDatesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
                throw new runtime.RequiredError('symbol', 'Required parameter requestParameters.symbol was null or undefined when calling getOptionExpirationDates.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/markets/stocks/options/expirations/{symbol}`.replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.ExpirationDateFromJSON));
        });
    }
    /**
     * Get option expiration dates for underlying symbol
     */
    getOptionExpirationDates(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOptionExpirationDatesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get the latest stock quote for a security
     */
    getQuoteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
                throw new runtime.RequiredError('symbol', 'Required parameter requestParameters.symbol was null or undefined when calling getQuote.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/markets/stocks/quotes/{symbol}`.replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.QuoteFromJSON(jsonValue));
        });
    }
    /**
     * Get the latest stock quote for a security
     */
    getQuote(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getQuoteRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get recent dividends in the last 6 months for a security
     */
    getRecentDividendsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
                throw new runtime.RequiredError('symbol', 'Required parameter requestParameters.symbol was null or undefined when calling getRecentDividends.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/markets/stocks/dividends/recent/{symbol}`.replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.DividendsFromJSON));
        });
    }
    /**
     * Get recent dividends in the last 6 months for a security
     */
    getRecentDividends(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRecentDividendsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get recent earnings for a security in the last 6 months
     */
    getRecentEarningsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
                throw new runtime.RequiredError('symbol', 'Required parameter requestParameters.symbol was null or undefined when calling getRecentEarnings.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/markets/stocks/earnings/recent/{symbol}`.replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.EarningsFromJSON));
        });
    }
    /**
     * Get recent earnings for a security in the last 6 months
     */
    getRecentEarnings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRecentEarningsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Retrieves recent splits for a security in the past 6 months
     */
    getRecentSplitsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
                throw new runtime.RequiredError('symbol', 'Required parameter requestParameters.symbol was null or undefined when calling getRecentSplits.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/markets/stocks/splits/recent/{symbol}`.replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.SplitFromJSON));
        });
    }
    /**
     * Retrieves recent splits for a security in the past 6 months
     */
    getRecentSplits(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRecentSplitsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get symbol stats
     */
    getStatsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
                throw new runtime.RequiredError('symbol', 'Required parameter requestParameters.symbol was null or undefined when calling getStats.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/markets/stats/{symbol}`.replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.StatsFromJSON(jsonValue));
        });
    }
    /**
     * Get symbol stats
     */
    getStats(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStatsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get strikes prices for symbol and expiration date
     */
    getStrikePricesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expirationDate === null || requestParameters.expirationDate === undefined) {
                throw new runtime.RequiredError('expirationDate', 'Required parameter requestParameters.expirationDate was null or undefined when calling getStrikePrices.');
            }
            if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
                throw new runtime.RequiredError('symbol', 'Required parameter requestParameters.symbol was null or undefined when calling getStrikePrices.');
            }
            const queryParameters = {};
            if (requestParameters.expirationDate !== undefined) {
                queryParameters['expirationDate'] = requestParameters.expirationDate;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/markets/stocks/options/strikes/{symbol}`.replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get strikes prices for symbol and expiration date
     */
    getStrikePrices(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStrikePricesRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get upcoming dividends for a security
     */
    getUpcomingDividendsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
                throw new runtime.RequiredError('symbol', 'Required parameter requestParameters.symbol was null or undefined when calling getUpcomingDividends.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/markets/stocks/dividends/upcoming/{symbol}`.replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.DividendsFromJSON));
        });
    }
    /**
     * Get upcoming dividends for a security
     */
    getUpcomingDividends(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUpcomingDividendsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get upcoming earnings for a security
     */
    getUpcomingEarningsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
                throw new runtime.RequiredError('symbol', 'Required parameter requestParameters.symbol was null or undefined when calling getUpcomingEarnings.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/markets/stocks/earnings/upcoming/{symbol}`.replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.UpcomingEarningsFromJSON));
        });
    }
    /**
     * Get upcoming earnings for a security
     */
    getUpcomingEarnings(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUpcomingEarningsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get upcoming earnings for the market
     */
    getUpcomingMarketEarningsRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/markets/stocks/earnings/upcoming`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.UpcomingEarningsFromJSON));
        });
    }
    /**
     * Get upcoming earnings for the market
     */
    getUpcomingMarketEarnings() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUpcomingMarketEarningsRaw();
            return yield response.value();
        });
    }
    /**
     * Retrieves upcoming splits for a security
     */
    getUpcomingSplitsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.symbol === null || requestParameters.symbol === undefined) {
                throw new runtime.RequiredError('symbol', 'Required parameter requestParameters.symbol was null or undefined when calling getUpcomingSplits.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/markets/stocks/splits/upcoming/{symbol}`.replace(`{${"symbol"}}`, encodeURIComponent(String(requestParameters.symbol))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.SplitFromJSON));
        });
    }
    /**
     * Retrieves upcoming splits for a security
     */
    getUpcomingSplits(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUpcomingSplitsRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.MarketApi = MarketApi;
